import React, { useState } from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import AuthVerify from './pages/AuthVerify';
import DetectorInfo from './pages/DetectorInfo';
import Footer from './components/Footer';
import AuthModal from './components/AuthModal';
import EmailVerificationModal from './components/EmailVerificationModal';
import { AuthProvider, useAuth } from './contexts/AuthContext';

function AppContent() {
  const location = useLocation();
  const { isAuthenticated, user, logout } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showEmailVerification, setShowEmailVerification] = useState(false);
  const [verificationEmail, setVerificationEmail] = useState('');

  const handleEmailSent = (email: string) => {
    setVerificationEmail(email);
    setShowAuthModal(false);
    setShowEmailVerification(true);
  };

  const scrollToWorkspace = () => {
    const workspace = document.getElementById('workspace');
    if (workspace) {
      workspace.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
      <div className="App">
        <div className="announcement-banner">
          <div className="announcement-content">
            <svg className="announcement-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span className="announcement-text">
              Novidades em breve! Estamos trabalhando em novas funcionalidades incríveis para melhorar sua experiência.
            </span>
          </div>
        </div>

        <header className="header">
          <div className="nav">
            <Link to="/" className="logo">
              <svg className="logo-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Humanizador
            </Link>
            <div className="nav-links">
              <Link to="/" className={location.pathname === '/' ? 'active' : ''}>Humanizador IA</Link>
              {isAuthenticated && (
                <Link to="/detectores" className={location.pathname === '/detectores' ? 'active' : ''}>Como Funciona</Link>
              )}
              <a href="#contact">Contato</a>
            </div>
            <div className="auth-buttons">
              {isAuthenticated ? (
                <>
                  <span className="user-name">{user?.displayName}</span>
                  <button className="logout-btn" onClick={logout}>Sair</button>
                </>
              ) : (
                <>
                  <button className="login-btn" onClick={() => setShowAuthModal(true)}>Entrar</button>
                  <button className="try-free-btn" onClick={scrollToWorkspace}>Experimente grátis</button>
                </>
              )}
            </div>
          </div>
        </header>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/auth/verify" element={<AuthVerify />} />
          <Route path="/detectores" element={<DetectorInfo />} />
        </Routes>

        <Footer />

        <AuthModal 
          isOpen={showAuthModal}
          onClose={() => setShowAuthModal(false)}
          onEmailSent={handleEmailSent}
        />
        
        <EmailVerificationModal
          isOpen={showEmailVerification}
          onClose={() => setShowEmailVerification(false)}
          email={verificationEmail}
        />
      </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;